
define("json!strings/tags.json", function(){ return {
    "sample.tag.open": "<a class='sample' href='{{sampleUri}}'>",
    "a.open": "<a class=\"{{linkClasses}}\" href=\"{{linkUri}}\">",
    "i.tag": "<i class=\"{{iconClasses}}\" aria-label=\"{{iconLabel}}\"></i>",
    "span.open": "<span class=\"{{spanClasses}}\">",
    "span.text.tag": "{{>span.open}}{{spanText}}{{>span.close}}",
    "ul.items.text": "<ul>{{#items}}<li>{{text}}</li>{{/items}}</ul>"
}
;});

